export class Color {
    public r: number = 0;
    public g: number = 0;
    public b: number = 0;
    public a: number = 1;

    constructor(color: string = null) {
        if (color)
            this.color = color;
    }

    public toString(): string {
        if (this.a === 1) {
            return "#" + this.componentToHex(this.r) + this.componentToHex(this.g) + this.componentToHex(this.b);
            // return "#" + ((1 << 24) + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1);
        }

        return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    }

    public get color(): string {
        return this.toString();
    }

    /**
     * @see https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
     */
    public set color(hex: string) {

        hex = hex.trim();

        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (result) {
            this.r = parseInt(result[1], 16);
            this.g = parseInt(result[2], 16);
            this.b = parseInt(result[3], 16);
            this.a = 1;
            return;
        }

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (result) {
            this.r = parseInt(result[1], 16);
            this.g = parseInt(result[2], 16);
            this.b = parseInt(result[3], 16);
            this.a = parseInt(result[4], 16) / 255;
            return;
        }

        var m = hex.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
        if (m) {
            this.r = parseInt(m[1]);
            this.g = parseInt(m[2]);
            this.b = parseInt(m[3]);
            return;
        }

        var m = hex.match(/^rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(([0-9]*[.])?[0-9]+)\s*\)$/i);
        if (m) {
            this.r = parseInt(m[1]);
            this.g = parseInt(m[2]);
            this.b = parseInt(m[3]);
            this.a = parseFloat(m[4]);
            return;
        }


    }

    public interpolateTo(color: Color, ratio: number): Color {
        var c = new Color();

        c.r = Math.floor(e5.Calc.clamp(this.r + (color.r - this.r) * ratio, 0, 255));
        c.g = Math.floor(e5.Calc.clamp(this.g + (color.g - this.g) * ratio, 0, 255));
        c.b = Math.floor(e5.Calc.clamp(this.b + (color.b - this.b) * ratio, 0, 255));

        return c;
    }

    public static interpolate(a: string, b: string, ratio: number): string {
        var ac = new Color(a);
        var bc = new Color(b);
        return ac.interpolateTo(bc, ratio).toString();
    }

    private componentToHex(c: number): string {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }

}